import * as actions from '../../actions/actionTypes';
import initialState from '../initialState';

export default function analyticsEntitlementReducer(
  state = initialState.analyticsEntitlementData,
  action
) {
  switch (action.type) {
    case actions.LOAD_ANALYTICS_ENTITLEMENT_SUCCESS:
      return action.analyticsEntitlementData;
    case actions.LOAD_ANALYTICS_ENTITLEMENT_FAILURE:
      return initialState.analyticsEntitlementData;
    default:
      return state;
  }
}
